import React from 'react';
import { useLocation } from 'react-router-dom';
import TableCompo from '../../../components/table/TableCompo';
import useCleanupOnRouteChange from '../../../utilities/Cleanup';
import usePaginatedData from '../../../utilities/Paginationdata';
const DailyRides = () => {
    console.count("DailyRides rendered");

    const driverId = useLocation().state?.driverId || '';
    console.log(driverId, "driverId in daily rides");

    const {
        data,
        prevData,
        page,
        setPage,
        isLoading,
        message,
        inputValue,
        handleSearch,
        filterValue,
        handleFilter,
    } = usePaginatedData({
        url: `${process.env.REACT_APP_URL}/api/rides/fetchRides`,
        localKeys: {
            search: 'search-trip',
            filter: 'filter-trip',
            page: 'pageno-trip',
            totalPage: 'totalpage-trip',
            totalData: 'totaldata-trip',
        },
        enableSearch: !driverId, // disable search if viewing from driver details
        enableFilter: true,
        queryParams: { driverId },
    });

    const filterOptions = [
        { value: 'completed', label: 'Completed', name: 'status' },
        { value: 'cancelled', label: 'Cancelled', name: 'status' },
        { value: 'onGoing', label: 'On going', name: 'status' },
        // { value: 'noResponse', label: 'no response', name: 'status' },
        // { value: 'notReached', label: 'not Reached', name: 'status' },
        { value: 'Ura premium', label: 'Ura Premium', name: 'medium' },
        { value: 'Ura Car', label: 'Ura Car', name: 'medium' },
        { value: 'Ura Bike', label: 'Ura Bike', name: 'medium' },
    ];

    useCleanupOnRouteChange(
        ['search-trip', 'filter-trip', 'totalpage-trip', 'totaldata-trip', 'pageno-trip'],
        '/rides'
    );

    return (
        <TableCompo
            title="Rides"
            data={data}
            prevData={prevData}
            page={page}
            setPage={setPage}
            isLoading={isLoading}
            message={message}
            search={!driverId}
            view={true}
            pagination={true}
            navPath={'details'}
            handleSearch={handleSearch}
            filter={true}
            filterval={handleFilter}
            fil={filterValue}
            filterOptions={filterOptions}
            inputValue={inputValue}
            rowClickable={true}
            serialNo={true}
        />
    );
};

export default DailyRides;
